import React, {useEffect, useState} from 'react';
import {Chip} from '@mui/material';
import {Typography} from '@fupa/fupa-uikit';
import {useHistory} from 'react-router';
import {clearPartner} from 'app/actions/partnerActions';
import {useDispatch} from 'react-redux';
import {LastItems, LastItemsWrapper} from 'app/styles/lastItemsStyles';
import styled from 'styled-components';
import {setSelectedDistrict} from 'app/actions/sessionActions';
import useDistrictUrls from 'app/hooks/useDistrictUrls';
import LocalStorageManager from 'app/services/web-storage/LocalStorageManager';
import {KEY_LAST_DISTRICTS} from 'app/helpers/lastItemsHelpers';

const Placeholder = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
  justify-content: center;
`;

export const LastDistricts = ({selectedDistrict}) => {
  const [lastDistricts, setLastDistricts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const localStorageManager = LocalStorageManager.getInstance();
    const lastDistrictsFromStorage = localStorageManager.getItem(KEY_LAST_DISTRICTS);
    setLastDistricts(lastDistrictsFromStorage);
    setIsLoading(false);
  }, []);

  let content;
  if (lastDistricts && lastDistricts.length > 1) {
    content = lastDistricts.map(district => {
      const {slug, name, regionSlug} = district;
      if (slug !== selectedDistrict.slug) {
        return <LastDistrict key={`last-visited-${slug}`} name={name} slug={slug} regionSlug={regionSlug} />;
      } else {
        return null;
      }
    });
  } else if (isLoading) {
    content = <Placeholder variant='body1'> </Placeholder>;
  } else {
    const label = 'Noch keine zuletzt besuchten Regionen';
    content = (
      <Placeholder>
        <Chip style={{borderStyle: 'dashed'}} label={label} variant='outlined' disabled={true} />
      </Placeholder>
    );
  }

  return (
    <LastItemsWrapper>
      <Typography variant='caption1'>Zuletzt besuchte Regionen</Typography>
      <LastItems>{content}</LastItems>
    </LastItemsWrapper>
  );
};

const LastDistrict = ({name, slug, regionSlug}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {districtMainUrl} = useDistrictUrls(slug);

  const handleClick = () => {
    dispatch(clearPartner());
    dispatch(setSelectedDistrict({slug, region: {slug: regionSlug}}));
    history.push(districtMainUrl);
  };

  return <Chip label={name} variant='outlined' onClick={handleClick} />;
};
